import { memo } from 'react';
import { TextField, Paper } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface TranslationEditRowDataProps {
  translations: string;
  handleChange: (e: string) => void;
}

const TranslationEditRowData = memo(({ translations, handleChange }: TranslationEditRowDataProps) => {
  const { t } = useTranslation();

  return (
    <Paper elevation={1}>
      <TextField
        id="comment-input"
        label={t('f-trans-raw-data')}
        variant="outlined"
        type="text"
        multiline
        fullWidth
        value={translations}
        onChange={(e) => handleChange(e.target.value)}
      />
    </Paper>
  );
});

export default TranslationEditRowData;
